// iframe事件清单
export const IFRAME_EVENT = {
  // 设置归属-关闭
  SET_SUBJECT_CLOSE: 'JLC_SET_SUBJECT_CLOSE',
  // 设置归属-完成
  SET_SUBJECT_COMPLETE: 'JLC_SET_SUBJECT_COMPLETE',
  // 选发票资料-关闭
  SELECT_INVOICE_INFO_CLOSE: 'JLC_SELECT_INVOICE_INFO_CLOSE',
  // 选发票资料-完成
  SELECT_INVOICE_INFO_COMPLETE: 'JLC_SELECT_INVOICE_INFO_COMPLETE',
  // 选发票资料-删除资料
  SELECT_INVOICE_INFO_DELETE: 'JLC_SELECT_INVOICE_INFO_DELETE',
  // 新增编辑发票-关闭
  UPSERT_INVOICE_INFO_CLOSE: 'JLC_UPSERT_INVOICE_INFO_CLOSE',
  // 新增编辑发票-完成
  UPSERT_INVOICE_INFO_COMPLETE: 'JLC_UPSERT_INVOICE_INFO_COMPLETE',
  // 企业更名-关闭
  COMPANY_RENAME_CLOSE: 'JLC_COMPANY_RENAME_CLOSE',
  // 企业更名-完成
  COMPANY_RENAME_COMPLETE: 'JLC_COMPANY_RENAME_COMPLETE',
  // 企业更名-撤销
  COMPANY_RENAME_REVOKE: 'JLC_COMPANY_RENAME_REVOKE',
};

// 获取当前环境的域名
export const getEnvDomain = () => {
  const env = typeof window === 'object' ? process.env.NEXT_PUBLIC_APP_ENV : process.env.APP_ENV;

  // 开发环境使用本地测试页面
  if (env === 'local' || !env) {
    return window.location.origin;
  }

  // 统一用member域，只因www生产的nginx会过滤掉.js等文件
  const domainMap = {
    dev: 'https://devmember.szlcsc.com',
    fat: 'https://fatmember.szlcsc.com',
    uat: 'https://uatmember.szlcsc.com',
    prod: 'https://member.szlcsc.com',
  };

  // return domainMap[env] || domainMap.prod;
  return '';
};

// 设置 iframe 监控（加载耗时和错误监听）
const setupIframeMonitoring = (iframe, id, src, startTime) => {
  try {
    // 监听 iframe 加载错误
    iframe.addEventListener('error', (event) => {
      try {
        const loadTime = Date.now() - startTime;
        console.error('[JLCIframe Load Error]', {
          iframeId: id,
          iframeSrc: src,
          message: 'iframe 加载失败',
          loadTime: `${loadTime}ms`,
          eventType: event && event.type,
          target: event && event.target && event.target.tagName,
          timeStamp: event && event.timeStamp,
        });
      } catch (err) {
        console.error('[Iframe] 加载错误监听异常:', err);
      }
    });

    // iframe 加载完成后尝试注入错误监听（仅同域可用）
    iframe.onload = () => {
      try {
        const loadTime = Date.now() - startTime;

        // 上报加载耗时
        console.error('[JLCIframe Load Time]', {
          iframeId: id,
          iframeSrc: src,
          loadTime: `${loadTime}ms`,
        });

        try {
          const iframeWindow = iframe.contentWindow;
          if (iframeWindow) {
            // 监听 iframe 内部的 JS 错误
            iframeWindow.addEventListener(
              'error',
              (event) => {
                try {
                  console.error('[JLCIframe JS Error]', {
                    iframeId: id,
                    iframeSrc: src,
                    message: event.message,
                    filename: event.filename,
                    lineno: event.lineno,
                    colno: event.colno,
                    stack: event.error && event.error.stack,
                  });
                } catch (err) {
                  console.error('[Iframe] JS错误监听异常:', err);
                }
              },
              true
            );

            // 监听 iframe 内部的 Promise 错误
            iframeWindow.addEventListener('unhandledrejection', (event) => {
              try {
                console.error('[JLCIframe Unhandled Rejection]', {
                  iframeId: id,
                  iframeSrc: src,
                  reason: event.reason && event.reason.toString(),
                  stack: event.reason && event.reason.stack,
                });
              } catch (err) {
                console.error('[Iframe] Promise错误监听异常:', err);
              }
            });
          }
        } catch {
          // 跨域时无法访问 contentWindow，无法注入错误监听（跨域限制）
          console.error('[JLCIframe] unknown internal error:', id);
        }
      } catch (err) {
        console.error('[JLCIframe] onload处理异常:', err);
      }
    };
  } catch (err) {
    console.error('[JLCIframe] 监控设置异常:', err);
  }
};

// iframe 工具函数
export const createFrame = (src, attrs = {}, container, id, zIndex = 100000) => {
  const iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.id = id || '';
  iframe.style.position = 'fixed';
  iframe.style.top = '0';
  iframe.style.left = '0';
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.zIndex = String(zIndex) || '100000';
  iframe.style.border = 'none';
  iframe.style.background = 'transparent';

  // 将外部传入的样式属性写入
  Object.keys(attrs).forEach((key) => {
    iframe.setAttribute(key, attrs[key]);
  });

  const iframeContainer = container || document.body;

  // 记录开始时间
  const startTime = Date.now();

  iframeContainer.appendChild(iframe);

  // 设置监控（加载耗时和错误监听）
  setupIframeMonitoring(iframe, id, src, startTime);

  const removeFrame = () => {
    if (iframeContainer.contains(iframe)) {
      iframeContainer.removeChild(iframe);
    }
  };

  return {
    iframe,
    removeFrame,
  };
};

// 监听message
export const listenMessage = (type, callback, once = false) => {
  const handler = (message) => {
    if (typeof message.data === 'string') {
      // 避免无法parse的数据导致报错
      try {
        const event = JSON.parse(message.data);
        if (event.type === type) {
          callback?.(event);
          if (once) {
            removeListener();
          }
        }
      } catch (err) {
        console.error('iframe 监听异常', err);
      }
    }
  };

  window.addEventListener('message', handler);

  const removeListener = () => {
    window.removeEventListener('message', handler);
  };

  return removeListener;
};

// 业务相关的 iframe 操作函数
export const invoiceIframeActions = {
  // 新增/编辑开票资料
  upsertInvoiceInfo: (invoiceInfoId, onComplete, onClose) => {
    const domain = getEnvDomain();
    const env = typeof window === 'object' ? process.env.NEXT_PUBLIC_APP_ENV : process.env.APP_ENV;

    // 开发环境使用本地测试页面
    const url =
      env === 'local' || !env
        ? `/test-iframe/upsert-invoice.html?source=LCSC&invoiceInfoId=${invoiceInfoId || ''}`
        : `${domain}/integrated/profile/invoice/upsert-info?source=LCSC&invoiceInfoId=${invoiceInfoId || ''}`;

    const { removeFrame } = createFrame(url, {}, undefined, 'jlc-upsert-invoice');

    // 关闭事件监听
    const removeListenClose = listenMessage(
      IFRAME_EVENT.UPSERT_INVOICE_INFO_CLOSE,
      () => {
        console.log('JLC_UPSERT_INVOICE_INFO_CLOSE');
        if (onClose) {
          onClose();
        }
        removeFrame();
      },
      true
    );

    // 完成事件监听
    listenMessage(
      IFRAME_EVENT.UPSERT_INVOICE_INFO_COMPLETE,
      (eventData) => {
        console.log('JLC_UPSERT_INVOICE_INFO_COMPLETE', eventData);
        removeFrame();
        removeListenClose();
        onComplete?.(eventData.data);
      },
      true
    );
  },

  // 选择开票资料
  selectInvoiceInfo: (onComplete) => {
    const domain = getEnvDomain();
    const env = typeof window === 'object' ? process.env.NEXT_PUBLIC_APP_ENV : process.env.APP_ENV;

    // 开发环境使用本地测试页面
    const url =
      env === 'local' || !env
        ? `/test-iframe/select-invoice.html?source=LCSC`
        : `${domain}/integrated/profile/invoice/select-info?source=LCSC`;

    const { removeFrame } = createFrame(url, {}, undefined, 'jlc-select-invoice');

    // 关闭事件监听
    const removeListenClose = listenMessage(
      IFRAME_EVENT.SELECT_INVOICE_INFO_CLOSE,
      () => {
        console.log('JLC_SELECT_INVOICE_INFO_CLOSE');
        removeFrame();
      },
      true
    );

    // 完成事件监听
    listenMessage(
      IFRAME_EVENT.SELECT_INVOICE_INFO_COMPLETE,
      (eventData) => {
        console.log('JLC_SELECT_INVOICE_INFO_COMPLETE', eventData);
        removeFrame();
        removeListenClose();
        onComplete?.(eventData.data);
      },
      true
    );
  },

  // 设置归属
  setSubject: (onComplete, onClose) => {
    const domain = getEnvDomain();
    const env = typeof window === 'object' ? process.env.NEXT_PUBLIC_APP_ENV : process.env.APP_ENV;

    // 开发环境使用本地测试页面
    const url =
      env === 'local' || !env
        ? `/test-iframe/set-subject.html?source=LCSC`
        : `${domain}/integrated/profile/subject/setting?source=LCSC`;

    const { removeFrame } = createFrame(url, {}, undefined, 'jlc-set-subject');

    // 关闭事件监听
    const removeListenClose = listenMessage(
      IFRAME_EVENT.SET_SUBJECT_CLOSE,
      () => {
        console.log('JLC_SET_SUBJECT_CLOSE');
        removeFrame();
        onClose?.();
      },
      true
    );

    // 完成事件监听
    listenMessage(
      IFRAME_EVENT.SET_SUBJECT_COMPLETE,
      (eventData) => {
        console.log('JLC_SET_SUBJECT_COMPLETE', eventData);
        removeFrame();
        removeListenClose();
        onComplete?.(eventData.data);
      },
      true
    );
  },

  // 企业更名
  companyRename: (onComplete) => {
    const domain = getEnvDomain();
    const env = typeof window === 'object' ? process.env.NEXT_PUBLIC_APP_ENV : process.env.APP_ENV;

    // 开发环境使用本地测试页面
    const url =
      env === 'local' || !env
        ? `/test-iframe/company-rename.html?source=LCSC`
        : `${domain}/integrated/profile/subject/company-rename?source=LCSC`;

    const { removeFrame } = createFrame(url, {}, undefined, 'jlc-company-rename');

    // 关闭事件监听
    const removeListenClose = listenMessage(
      IFRAME_EVENT.COMPANY_RENAME_CLOSE,
      () => {
        console.log('JLC_COMPANY_RENAME_CLOSE');
        removeFrame();
      },
      true
    );

    // 完成事件监听
    listenMessage(
      IFRAME_EVENT.COMPANY_RENAME_COMPLETE,
      (eventData) => {
        console.log('JLC_COMPANY_RENAME_COMPLETE', eventData);
        removeFrame();
        removeListenClose();
        onComplete?.(eventData.data);
      },
      true
    );
  },
};
